
import './App.css';
import Sciqusbanner from "./Component/Sciqusbanner/Sciqusbanner";
import WeCompanyName from "./Component/WeCompanyName/WeCompanyName";
import WhatIsSciqusams from "./Component/WhatIsSciqusams/WhatIsSciqusams";
import CustomerInsights from "./Component/CustomerInsights/CustomerInsights";
import AccountManagementPlatform from "./Component/AccountManagementPlatform/AccountManagementPlatform";
import Benefits from "./Component/Benefits/Benefits";
import SciqusAmsServices from "./Component/SciqusAMSServices/SciqusAMSServices";
import ImplementationProcess from "./Component/ImplementationProcess/ImplementationProcess";
import WhyChooseUs from "./Component/WhyChooseUs/WhyChooseUs";
import ContactUs from "./Component/ContactUs/ContactUs";
import SciqusHeader from "./Component/SciqusHeader/SciqusHeader";
import SciqusFooter from "./Component/SciqusFooter/SciqusFooter";
import ScrollToTopButton from "./Component/ScrollToTopButton/ScrollToTopButton";
// import NewBenefits from "./Component/Benefits/NewBenefits";

function App () {
	return (
		<>
			<SciqusHeader/>
			<Sciqusbanner/>
			{/*<div className="pageContainer">*/}
			<WeCompanyName/>
			<WhatIsSciqusams/>
			<CustomerInsights/>
			<AccountManagementPlatform/>
			<Benefits/>
			{/*<NewBenefits />*/}
			<SciqusAmsServices/>
			<ImplementationProcess/>
			<WhyChooseUs/>
			<ContactUs/>
			<SciqusFooter/>
			<ScrollToTopButton />
			{/*</div>*/}
		</>
	);
}

export default App;
